<template>
    <fragment>

        <Title> {{activityName}} </Title>

        <!-- 这里需要判断 是否是特殊活动 如果是特殊的活动 带loading 页 引导页 活动结束展示页  那逻辑需要改写 -->
        <fragment v-if="containGlobalPage">
            <!-- 如果包含加载页 引导页 活动结束展示页 等全局配置页面 -->
            <div :key="index" v-for="(item, index) in pageContent.list">
                <fragment v-if="item.type === 'template'">
                    <!--  -->
                    <!-- 集卡活动组件 -->
                    <Collect v-if="item.name === 'collect'" :info="item" :pageContent="pageContent"
                        :pageConfigContent="pageConfigContent" :activityId="activityId" :activityStatus="activityStatus"
                        :openId="openId" :activityType="pageType" :parentList="pageContent.list"
                        @hotAreaHandleClick="hotAreaHandleClick" />
                </fragment>
            </div>
        </fragment>

        <fragment v-else>
            <!-- 如果全局配置页面 -->
            <div :key="index" v-for="(item, index) in pageContent.list">

                <!-- 图片 组件 -->
                <NewImg v-if="item.name === 'img'" :info="item" :activityId="activityId"
                    :activityStatus="activityStatus" :activityType="pageType" @handleImgClick="handleImgClick" />

                <!-- 音频 组件 -->
                <NewAudio v-if="item.name === 'audio'" :info="item" :activityId="activityId"
                    :activityStatus="activityStatus" :activityType="pageType" @handleAudioClick="handleAudioClick" />

                <!-- 视频 组件 -->
                <NewVideo v-if="item.name === 'video'" :info="item" :activityId="activityId"
                    :activityStatus="activityStatus" :activityType="pageType" @handleVideoClick="handleVideoClick" />

                <!-- 悬浮左 组件 -->
                <FixLeft v-if="item.name === 'fixLeft'" :info="item" :activityId="activityId"
                    :activityStatus="activityStatus" :activityType="pageType" @handleFixClick="handleFixClick" />

                <!-- 悬浮右 组件 -->
                <FixRight v-if="item.name === 'fixRight'" :info="item" :activityId="activityId"
                    :activityStatus="activityStatus" :activityType="pageType" @handleFixClick="handleFixClick" />

            </div>
        </fragment>

    </fragment>
</template>

<script>

/**
 * 如果不包含模板型组件 所有的组件列表都在顶级 
 * 如果包含模板型组件 组件列表需要下沉到 模板型组件内部 虽然这样会有代码冗余但是目前没有更好的解决方案
 * 如果不下沉到模板型组件内容，需要处理的业务逻辑都会上升到顶级页面中，会大幅度增加顶级页面的业务复杂度，这个问题归根结底是产品设计方案的问题
 * 沉淀到 模板型组件内部这块儿的逻辑是可以优化的，可以把遍历列表和点击操作函数做抽离 抽离成一个公共组件
 */

import { isMiniApplets } from "@/utils/browser";
import { getQueryString, loadScript } from "@/utils/utils"

let closeIcon = require('@/assets/imgs/close.png')

export default {

    name: 'New',

    computed: {},

    provide() {
        return {
            $closeIcon: closeIcon,
            getEnterSource: () => this.enterSource,

        }
    },

    data() {
        return {

            openId: '',

            userId: '',

            enterSource: '',

            activityStatus: '', // 活动状态

            activityName: '', // 活动名称

            activityId: '', // 活动id

            pageNo: '', // HGS 配置的页面编码

            pageType: undefined, // 活动类型

            pageContent: {}, // HGS 直出的活动配置内容

            pageConfigContent: {}, // HGS 直出的页面配置内容

            showPopup: true, // 是否展示弹出层

            containGlobalPage: false, // 是否包含加载页 引导页 活动结束展示页等全局配置页面

            test: '', // 是否测试环境
        }
    },

    created() { // created 生命周期里做一些不和 dom交互的操作 
        this.getRouteParams()
    },

    mounted() {

        this.getPageConfig().then(id => {
            this.pageInitPoint()
            // if (id) {
            //     this.initTalkingDataTrack(id)
            // }
        })
    },

    methods: {

        getRouteParams() { // 获取路由信息 // 这里的路由信息 可能还有其他的扩容的信息 
            this.activityId = getQueryString("activityId");
            this.pageNo = getQueryString("pageNo");
            this.openId = getQueryString("openId");
            this.userId = getQueryString("userId");
            this.test = getQueryString("test")
            this.enterSource = getQueryString("enterSource")
            if (this.openId) {
                localStorage.setItem("openId", this.openId)
            }
            if (this.userId) {
                localStorage.setItem("userId", this.userId)
            }
        },

        getPageConfig() {
            return new Promise((resolve, reject) => {
                let params = {
                    activityId: this.activityId,
                    openId: this.openId,
                    pageNo: this.pageNo,
                    test: this.test
                };
                this.$ebLoading.show()
                this.$fetch(
                    {
                        url: "/ehs/activity/page/config",
                        method: "post"
                    },
                    params
                ).then(res => {
                    this.$ebLoading.hide()
                    if (res.success) {
                        let { model = {} } = res
                        this.pageContent = {}
                        this.pageType = model.pageType
                        setTimeout(() => {
                            this.activityStatus = model.activityStatus || 3
                            this.activityName = model.activityName
                            const { pageConfigJson = {} } = JSON.parse(model.pageContent)
                            this.pageContent = JSON.parse(model.pageContent)

                            this.pageConfigContent = pageConfigJson
                            this.checkGlobalPage()
                        }, 300)
                        resolve(model.talkingDataAppId)
                    } else {
                        if (res.errorCode == "CLA100077") {
                            return
                        }
                        this.toast(res.errorMessage)
                    }
                }).finally(() => {
                    this.$ebLoading.hide()
                })
            })
        },

        pageInitPoint() { // 页面初始化打点
            this.$log.senLog({
                pointID: '12010001',
                eventType: 1,
                businessData: {
                    enterSource: this.enterSource || '',
                    activityType: this.pageType !== undefined ? this.pageType : '',
                    activityId: this.activityId || ''
                }
            })
        },

        // initTalkingDataTrack(id) {
        //     loadScript(`https://jic.talkingdata.com/app/h5/v1?appid=${id}&vn=HDB&vc=1.0.0`).then(() => {
        //         try {
        //             TDAPP.onEvent("HDB", "活动配置", {
        //                 activityId: this.activityId,
        //                 openId: this.openId,
        //                 pageNo: this.pageNo
        //             })
        //         } catch (e) {
        //             console.log('打点失败', e)
        //         }
        //     })
        // },

        checkGlobalPage() { // 检查是否包含全局配置页面  这个配置函数要怎么写才合适 才通用呢？ // 目前的业务逻辑是 含有模板型组件 一般是 集卡 抽奖和 排行榜
            if (this.pageContent && this.pageContent.list && Array.isArray(this.pageContent.list)) {
                let status = this.pageContent.list.some(item => item.type === 'template')
                this.containGlobalPage = status
            }
        },

        handleImgClick(e) { // 图片点击操作
            this.hotAreaHandleClick(e)
        },

        handleAudioClick(e) { // 音频点击事件
            this.hotAreaHandleClick(e)
        },

        handleVideoClick(e) { // 视频点击操作
            this.hotAreaHandleClick(e)
        },

        handleFixClick(e) { // 悬浮点击操作
            this.hotAreaHandleClick(e)
        },

        hotAreaHandleClick(val) { // 热区点击事件 所有子组件内的事件全部上升到这里进行触发
            console.log('上升到顶级组件中处理', val)
            if (val.jumpType == 2) {
                this.pageNo = val.pagePath;
                this.getPageConfig();
            } else if ([3, 4].includes(val.jumpType)) {
                this.urlFor(val);
            } else if (val.jumpType == 1) { // 无跳转
                console.log('无跳转')
            }
        },

        toast(txt, duration) { // 封装统一的信息处理函数 这个函数为什么不直接弄到 Vue.prototype上呢？
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },



    }
}

</script>

<style lang="scss" scoped>

</style>